<template>
  <section class="news">
    <div class="news-container">
      <div class="news-title">
        <p>NEWS</p>
        <h2>最新活動消息</h2>
        <p>最新優惠訊息不要錯過，快來看看有哪些誘人優惠和活動。</p>
        <a href="#" class="btn">查看更多</a>
      </div>
      <div class="news-slider">
        <div class="news-items">
          <div v-for="item in news" :key="item.id" class="news-item">
            <div class="news-card">
              <img :src="item.image" :alt="'news-' + item.id">
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'NewsSection',
  computed: {
    ...mapState(['news'])
  }
}
</script>

<style scoped>
.news {
    background-color: #FCF8F3;
    padding: 3rem 0;
    margin: 5rem auto 10rem auto;
}

.news .news-container {
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 2rem;
    flex-wrap: wrap;
}

.news .news-container .news-title {
    flex: 1;
    font-size: 1.5rem;
    font-weight: 300;
    max-width: 300px;
}

.news .news-container .news-title p {
    font-size: 1rem;
    color: #555;
    margin-bottom: 0.5rem;
}

.news .news-container .news-title h2 {
    font-size: 3rem;
    font-weight: 700;
    color: #333;
    margin: 0.5rem 0;
}

.news .news-container .news-title .btn {
    border: 1px solid #F99393;
    color: #F99393;
    padding: 0.5rem 1.2rem;
    border-radius: 30px;
    font-size: 1rem;
    font-weight: 300;
    text-decoration: none;
    transition: all 0.3s ease;
}

.news .news-container .news-title .btn:hover {
    background-color: #F99393;
    color: #fff;
}

.news .news-container .news-slider {
    flex: 2;
    position: relative;
    overflow: hidden;
}

.news .news-container .news-slider .news-items {
    display: flex;
    gap: 1rem;
    transition: transform 0.3s ease;
}

.news .news-container .news-slider .news-item {
    min-width: 280px;
    flex-shrink: 0;
}

.news .news-container .news-slider .news-item .news-card {
    background: white;
    border-radius: 1rem;
    overflow: hidden;
    text-align: center;
}

.news .news-container .news-slider .news-item .news-card img {
    width: 100%;
    display: block;
}
</style> 